export const DEFAULT_REVIEW_COUNT = 20;
export const DESCRIPTION_MIN_LENGTH = 40;
